import React from 'react'
import Box from '@material-ui/core/Box'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import HeaderSchedule from './header-schedule'
import makeStyles from '@material-ui/core/styles/makeStyles'
import ReadMore from 'components/program-marketing/read-more'
import useIsMobile from 'components/program-marketing/useIsMobile'

const useStyles = makeStyles(theme => ({
  accessCode: {
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: '14px',
    lineHeight: '18px',
    border: '1px solid #FFFFFF',
    boxSizing: 'border-box',
    borderRadius: '4px',
    padding: '8px 18px',
    color: theme.palette.primary.contrastText,
    marginBottom: '16px',
    display: 'inline-block',
  },
  headerSectionBg: {
    backgroundColor: theme.palette.background.dark,
    color: theme.palette.primary.contrastText,
    paddingTop: '86px',
  },
}))

const HeaderSection = ({
  program,
  events = [],
  viewProgramDesc,
  eventDates,
}) => {
  const isMobile = useIsMobile()
  const classes = useStyles()
  return (
    <Box
      px={isMobile ? 0 : 4}
      pt={isMobile ? 2 : 4}
      pb={isMobile ? 12 : 4}
      className={classes.headerSectionBg}
    >
      <Box mx={isMobile ? 2 : 12} my={10}>
        <Grid container>
          <Grid item sm={12} md={8}>
            {program.registrationStatus === 'CODE_REQUIRED' && (
              <div className={classes.accessCode}>Access Code Required</div>
            )}

            {!isMobile && (
              <HeaderSchedule
                eventCount={events.length}
                eventDates={eventDates}
                isMobile={isMobile}
              />
            )}

            <Typography variant="h1" align="left" gutterBottom>
              {program.name}
            </Typography>

            {isMobile && (
              <HeaderSchedule
                eventCount={events.length}
                eventDates={eventDates}
                isMobile={isMobile}
              />
            )}

            {program.description && (
              <ReadMore
                text={program.description}
                onClick={viewProgramDesc}
                maxLine="2"
                maxLineMobile="3"
              />
            )}
          </Grid>
        </Grid>
      </Box>
    </Box>
  )
}

export default HeaderSection
